
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"19","cy":"19","r":"19","fill":"#F07300"}}),_c('path',{attrs:{"d":"M12.738 20.65h1.084v1.905h-1.084v2.263H10.27v-2.263H6.146L6 21.045l4.27-6.87v-.021h2.468v6.496zm-4.387 0h1.919v-3.28l-.154.248-1.765 3.032zM22.311 20.46c0 1.44-.325 2.551-.974 3.332-.645.782-1.555 1.172-2.732 1.172-1.186 0-2.105-.393-2.754-1.179-.65-.786-.974-1.894-.974-3.325v-1.948c0-1.44.322-2.552.967-3.333.65-.781 1.565-1.172 2.746-1.172 1.182 0 2.098.393 2.747 1.18.65.786.974 1.897.974 3.332v1.941zm-2.468-2.263c0-.767-.1-1.338-.3-1.714-.2-.38-.518-.571-.953-.571-.424 0-.735.175-.93.527-.19.352-.293.884-.308 1.597v2.724c0 .796.1 1.38.3 1.75.201.367.518.55.953.55.42 0 .73-.178.93-.535.2-.36.303-.925.308-1.691v-2.637zM29.555 14v1.94h-.11c-.923 0-1.682.223-2.278.667-.59.44-.955 1.053-1.091 1.839.556-.547 1.26-.82 2.11-.82.922 0 1.657.336 2.204 1.01.546.674.82 1.558.82 2.652 0 .678-.161 1.3-.483 1.867a3.417 3.417 0 01-1.34 1.333 3.854 3.854 0 01-1.905.476c-.757 0-1.433-.17-2.029-.512a3.575 3.575 0 01-1.392-1.48c-.331-.64-.502-1.377-.512-2.212v-.989c0-1.098.234-2.085.703-2.959a5.142 5.142 0 012.021-2.065c.875-.498 1.844-.747 2.908-.747h.374zm-2.227 5.515c-.327 0-.6.076-.82.227-.22.152-.383.337-.49.557v.74c0 1.347.465 2.021 1.398 2.021.376 0 .689-.168.938-.505.253-.337.38-.76.38-1.267 0-.523-.129-.948-.388-1.275a1.217 1.217 0 00-1.018-.498z","fill":"#fff"}})])
          )
        }
      }
    